/* global LazyLoad */

(function ($) {

    $.widget('femcare.heroSlider', {
        options: {
            slideSelector: null,
            sliderSelector: null,
            freezeSliderClass: null,
            nextButtonSelector: null,
            previousButtonSelector: null,
            pagionationSelector: null,
            bulletClass:null,
            bulletActiveClass: null,
            titleSelector: null
         },
        _slideAnimationSpeed: 1000,
        _isActivePlayerInGallery: false,

        _create: function () {
            // If only single slide don't init slider
            if (this.element.find(this.options.slideSelector).length <= 1) {
                return;
            }

            this.$pageTitleOverlay = this.element.find(this.options.titleSelector);
            this.$slider = this.element.find(this.options.sliderSelector);

            var autoplayIntervalSeconds = $(this.element).attr('data-autoplay-interval-seconds');
            var autoplayIntervalMilliseconds = parseFloat(autoplayIntervalSeconds.replace(',', '.')) * 1000;

            this.swiper = new Swiper(this.$slider[0], {
                slidesPerView: 1,
                spaceBetween: 0,
                direction: 'horizontal',
                lazy: {
                    loadOnTransitionStart: true
                },
                autoplay: {
                    delay: autoplayIntervalMilliseconds,
                    disableOnInteraction: false
                },
                loop: true,
                speed: this._slideAnimationSpeed,
                navigation: {
                    nextEl: this.$slider.find(this.options.nextButtonSelector)[0],
                    prevEl: this.$slider.find(this.options.previousButtonSelector)[0]
                },
                pagination: {
                    el: this.element.find(this.options.pagionationSelector)[0],
                    type: 'bullets',
                    bulletElement: 'button',
                    clickable: true,
                    bulletClass: this.options.bulletClass,
                    bulletActiveClass: this.options.bulletActiveClass
                },
                on: {
                    init: function() {
                        new LazyLoad({
                            elements_selector: '.swiper-slide-duplicate .lazy',
                        });
                    }
                }
            });

            this.swiper.on('slideChangeTransitionStart', this._onTransition.bind(this));
            this.swiper.on('slideChangeTransitionEnd', this._onTransitioned.bind(this));

            femcare.shared.pubsub.subscribe('PLATFORM_INLINE_VIDEO_PLAY', this._onVideoPlay.bind(this));
            femcare.shared.pubsub.subscribe('PLATFORM_MODAL_VIDEO_PLAY', this._onVideoPlay.bind(this));
            femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_PLAYS', this._onVideoPlay.bind(this));

            femcare.shared.pubsub.subscribe('PLATFORM_INLINE_VIDEO_FINISH', this._onVideoFinish.bind(this));
            femcare.shared.pubsub.subscribe('PLATFORM_MODAL_VIDEO_FINISH', this._onVideoFinish.bind(this));
            femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_FINISH', this._onVideoFinish.bind(this));

            femcare.shared.pubsub.subscribe('PLATFORM_INLINE_VIDEO_CLICK', this._onInlinePlatformVideoClick.bind(this));
            femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_BUFFERING', this._onYoutubeVideoBuffering.bind(this));
        },

        _onVideoPlay: function (data) {
            if (this._isVideoWithinGallery(data.$trigger)) {
                this._stopAutoplay();
                this._isActivePlayerInGallery = true;
                this.$pageTitleOverlay.addClass('page-title-overlay--video-active');
            } else {
                this._isActivePlayerInGallery = false;
                this._startAutoplay();
            }
        },

        _onVideoFinish: function (data) {
            if (this._isVideoWithinGallery(data.$trigger)) {
                this._startAutoplay();
                this._isActivePlayerInGallery = false;
                this.$pageTitleOverlay.removeClass('page-title-overlay--video-active');
            }
        },

        _onInlinePlatformVideoClick: function (data) {
            if (this._isVideoWithinGallery(data.$trigger)) {
                this._stopAutoplay();
            }
        },

        _onYoutubeVideoBuffering: function (data) {
            if (this._isVideoWithinGallery(data.$trigger)) {
                this._stopAutoplay();
            }
        },

        _isVideoWithinGallery: function ($videoTrigger) {
            return this.$slider.find($videoTrigger).length;
        },

        _stopAutoplay: function () {
            this.swiper.autoplay.stop();
        },

        _startAutoplay: function () {
            this.swiper.autoplay.start();
        },

        _onTransition: function () {
            this.$slider.addClass(this.options.freezeSliderClass);
            this._stopAutoplay();
            this.$pageTitleOverlay.removeClass('page-title-overlay--video-active');

            if (this._isActivePlayerInGallery === true) {
                femcare.shared.pubsub.publish('REQUEST_STOP_ACTIVE_PLAYER');
                this._isActivePlayerInGallery = false;
            }
        },

        _onTransitioned: function () {
            this._startAutoplay();
            this.$slider.removeClass(this.options.freezeSliderClass);
        }

    });

})(jQuery);
